require('./bootstrap');
require('./iconify-local');

window.showModal = function (id) {
  const modal = new window.bootstrap.Modal(document.getElementById(id), {
    keyboard: false,
  })
  modal.show()
}

window.hideModal = function (id) {
  const modal = window.bootstrap.Modal.getOrCreateInstance(document.getElementById(id))
  modal.hide()
}

window.loader = null

document.addEventListener('DOMContentLoaded', function () {
  const nav = document.getElementById('sideNav')
  const navTrigger = document.getElementById('sidemenuTrigger')
  const clientMain = document.getElementById('mainWrapperElement')

  if (navTrigger && nav) {
    navTrigger.addEventListener('click', function () {
      nav.classList.toggle('sidenav-closed')
      setTimeout(function () {
        nav.classList.toggle('sidenav-menu-elements')
      }, 300)
    })
  }

  if (!clientMain && window.innerWidth < 1200 && nav) {
    nav.classList.add('sidenav-closed')
  }

  window.loader = document.getElementById('loaderEl')
  window.$('#loaderEl').addClass('d-none')
})

// flatpickr
import flatpickr from 'flatpickr';
window.flatpickr = flatpickr;

// swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import initClientSidenav from './client/sidenav';
window.Swiper = Swiper;
window.SwiperModules = { Navigation, Pagination, Autoplay };


// chartjs
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
window.Chart = Chart;


// toastr
window.toastr = require('toastr');

require('./utils/socialTokens');
require('./location-picker');
require('./campaigns/create_step_3');
require('./influencer/email-preferences');
require('./influencer/sms-preferences');
require('./influencer/tutorial-video');

const INFLUENCER_CAMPAIGN_RETURN_TO_KEY = 'influencer_campaign_return_to';
const ALLOWED_INFLUENCER_CAMPAIGN_SOURCE_PATHS = new Set([
  '/influencer',
  '/influencer/',
  '/influencer/campaign-rewards',
  '/influencer/notifications',
]);
const ALLOWED_INFLUENCER_CAMPAIGN_SOURCE_PREFIXES = [
  '/influencer/notifications/',
];

// Only allow a small set of known influencer pages to act as campaign "back" sources.
function isAllowedInfluencerCampaignSourcePath(path) {
  if (typeof path !== 'string') return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//')) return false;
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(path)) return false;

  const normalizedPath = path.split('?')[0].replace(/\/+$/, '') || '/';
  if (ALLOWED_INFLUENCER_CAMPAIGN_SOURCE_PATHS.has(normalizedPath)) {
    return true;
  }

  return ALLOWED_INFLUENCER_CAMPAIGN_SOURCE_PREFIXES.some((prefix) => (
    normalizedPath.startsWith(prefix)
  ));
}

// When opening a campaign, remember the current allowed list page for the Back link.
function rememberInfluencerCampaignSource() {
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    if (!destination.pathname.startsWith('/influencer/apply/')) return;

    const currentPath = `${window.location.pathname}${window.location.search}`;
    if (!isAllowedInfluencerCampaignSourcePath(currentPath)) return;
    if (currentPath.startsWith('/influencer/apply/')) return;

    try {
      window.sessionStorage.setItem(INFLUENCER_CAMPAIGN_RETURN_TO_KEY, currentPath);
    } catch (e) {
      // Ignore storage failures (e.g. strict privacy modes).
    }
  });
}

// On campaign details, hydrate the Back link from the remembered source page.
function hydrateInfluencerSponsorshipBackLink() {
  if (document.body.getAttribute('data-page') !== 'influencer-sponsorship') return;

  const backLink = document.querySelector('.sponsorship-back-link');
  if (!backLink) return;

  let rememberedPath = null;
  try {
    rememberedPath = window.sessionStorage.getItem(INFLUENCER_CAMPAIGN_RETURN_TO_KEY);
  } catch (e) {
    return;
  }
  if (!isAllowedInfluencerCampaignSourcePath(rememberedPath)) return;
  if (rememberedPath.startsWith('/influencer/apply/')) return;

  backLink.setAttribute('href', rememberedPath);
}

// Page-specific scripts: load only when data-page matches (dynamic import)
document.addEventListener('DOMContentLoaded', function () {
  rememberInfluencerCampaignSource();
  hydrateInfluencerSponsorshipBackLink();

  const pageId = document.body.getAttribute('data-page');
  if (!pageId) return;
  switch (pageId) {
    case 'auth-login':
      import('./auth/login').then(function (module) { module.default(); });
      break;
    case 'auth-client-register':
      import('./auth/client-register').then(function (module) { module.default(); });
      break;
    case 'auth-influencer-register':
      import('./auth/influencer-register').then(function (module) { module.default(); });
      break;
    case 'auth-influencer-register-step2':
      import('./auth/influencer-register-step2').then(function (module) { module.default(); });
      break;
    case 'auth-password-email':
      import('./auth/password-email').then(function (module) { module.default(); });
      break;
    case 'auth-password-reset':
      import('./auth/password-reset').then(function (module) { module.default(); });
      break;
    case 'client-dashboard':
      import('./client/dashboard').then(function (module) { module.default(); });
      break;
    case 'client-campaign-list':
      import('./client/campaign-list').then(function (module) { module.default(); });
      break;
    case 'client-notifications':
      import('./client/notifications').then(function (module) { module.default(); });
      break;
    case 'campaign-create-step-1':
      import('./campaigns/create_step_1').then(function (module) { module.default(); });
      break;
    case 'campaign-create-step-2':
      import('./campaigns/create_step_2').then(function (module) { module.default(); });
      break;
    case 'influencer-dashboard':
      import('./influencer/dashboard').then(function (m) { m.default(); });
      break;
    case 'influencer-sponsorship':
      import('./influencer/sponsorship').then(function (m) { m.default(); });
      break;
    case 'campaign-details':
      import('./campaigns/details').then(function (m) { m.default(); });
      break;
    case 'campaign-submissions':
      import('./campaigns/submissions').then(function (m) { m.default(); });
      break;
    case 'campaign-applicant-submissions':
      import('./campaigns/applicant-submissions').then(function (m) { m.default(); });
      break;
    case 'campaign-applicants':
      import('./campaigns/applicants').then(function (m) { m.default(); });
      break;
    case 'campaign-rewards-new':
      import('./influencer/campaign-rewards-new').then(function (m) { m.default(); });
      break;
    case 'client-rewards':
      import('./client/rewards').then(function (m) { m.default(); });
      break;
    case 'client-profile':
      import('./client/profile').then(function (m) { m.default(); });
      break;
    case 'client-creators':
      import('./client/creators').then(function (m) { m.default(); });
      break;
    case 'client-marketing':
      import('./client/marketing').then(function (m) { m.default(); });
      break;
    case 'influencer-profile':
      import('./influencer/profile').then(function (m) { m.default(); });
      break;
    default:
      break;
  }
});

document.addEventListener('DOMContentLoaded', initClientSidenav);

// window.onload = function () {
// }


// window.Vue = require('vue').default;
// window.Vue.component('milestones-configuration', require('../js/vue-components/MilestonesConfiguration.vue').default);

// new window.Vue({
//     el: '#app',
// });
// datepicker
// import datepicker from 'jquery-datetimepicker'
// window.datepicker = datepicker
